export default "__VITE_ASSET__CSNApYhC__"